// extracted by mini-css-extract-plugin
export var ohnohoney = "Honeypot-module--ohnohoney--7b61f";